<!-- template for the modal component -->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-left
      wrap>
      <claims-summary
        :claims="claims"
        :disable-application-link="disableApplicationLink"
        @navigateToApplicationInProgress="navigateToApplicationInProgress"/>
      <v-flex md12>
        <h3 class="heading-4">{{ 'krita.claims.unfactoredclaims' | translate }}</h3>
        <br >
        <v-card>
          <search-text-field
            :search-phrase="unfactoredSearch"
            :row-count="unfactoredClaimsRowCount"
            @search="unfactoredSearchRefresh"
          />
          <unfactored-claims-datagrid
            :unfactored-claims="unfactoredClaims"
            :loading-unfactored-claims="loadingUnfactoredClaims"
            :rows-per-page="unfactoredRowsPerPage"
            @refreshWithSort="refreshUnfactoredWithSort"
            @changeUnfactoredClaimsStatus="changeUnfactoredClaimsStatus"/>
          <div class="text-xs-center pt-2">
            <pagination
              :selected-page="unfactoredSelectedPage"
              :rows-per-page="unfactoredRowsPerPage"
              :row-count="unfactoredClaimsRowCount"
              @changeDisplayedRowCount="unfactoredChangeDisplayedRowCount"
              @clickedPage="changeUnfactoredPage"/>
          </div>
        </v-card>
        <unfactored-claims-controllers
          :unfactored-claims="unfactoredClaims"
          :creating-factoring="creatingFactoring"
          class="controllers"
          @createFactoring="createFactoring"
          @clearState="clearState"/>
      </v-flex>

      <v-flex md12>
        <h3 class="heading-4">{{ 'krita.claims.overduefactorings' | translate }}</h3>
        <br >
        <v-card>
          <search-text-field
            :search-phrase="overdueSearch"
            :row-count="overdueFactoringsRowCount"
            @search="overdueSearchRefresh"
          />
          <overdue-factorings-datagrid
            :overdue-factorings="overdueFactorings"
            :loading-overdue-factorings="loadingOverdueFactorings"
            :row-count="overdueRowsPerPage"
            @changeOverdueFactoringsStatus="changeOverdueFactoringsStatus"
            @refreshWithSort="refreshOverdueWithSort"/>
          <!--          <div class="text-xs-center pt-2">-->
          <pagination
            :selected-page="overdueSelectedPage"
            :rows-per-page="overdueRowsPerPage"
            :row-count="overdueFactoringsRowCount"
            @changeDisplayedRowCount="factoringsChangeDisplayedRowCount"
            @clickedPage="changeOverduePage"/>
            <!--          </div>-->
        </v-card>
        <overdue-factorings-controllers
          :overdue-factorings="overdueFactorings"
          :overdue-selection="overdueSelection"
          :creating-repayment="creatingRepayment"
          class="controllers"
          @createRepayment="createRepayment"
          @clearState="clearState"
          @filterFactorings="filterFactorings"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapState} from 'vuex';
import Pagination from './controllers/Pagination.vue';
import SearchTextField from './controllers/SearchTextField';
import ClaimsSummary from './claims/ClaimsSummary.vue';
import UnfactoredClaimsControllers from './claims/UnfactoredClaimsControllers.vue';
import UnfactoredClaimsDatagrid from './claims/UnfactoredClaimsDatagrid.vue';
import OverdueFactoringsControllers from './claims/OverdueFactoringsControllers.vue';
import OverdueFactoringsDatagrid from './claims/OverdueFactoringsDatagrid.vue';
	export default {
	    components: {Pagination, ClaimsSummary, UnfactoredClaimsControllers, UnfactoredClaimsDatagrid, OverdueFactoringsControllers, OverdueFactoringsDatagrid, SearchTextField},
      data: () => ({
        showModal: false,
        claims: {},
        creatingRepayment: false,
        creatingFactoring: false,
        loadingClaims: false,
        loadingUnfactoredClaims: false,
        loadingOverdueFactorings: false,

        unfactoredSort: {finalDueDate:'desc'},
        unfactoredClaims: [],
        unfactoredClaimsRowCount: '',
        unfactoredRowsPerPage: 5,
        unfactoredSearch:'',
        unfactoredSelectedPage: 1,

        overdueFactorings: [],
        overdueFactoringsRowCount: 0,
        overdueRowsPerPage: 5,
        overdueSelection: 'all',
        overdueSort: {factoringDueDate:'asc'},
        overdueSearch:'',
        overdueSelectedPage: 1,

        navigateToApplicationDetailSwitch: false,
        applicationDetailId: 0,
        disableApplicationLink: false
      }),
	    computed: {
          ...mapState({
            UserInfo: state => state.userInfo
          })
        },
      watch: {
        UserInfo ()
        {
          this.refreshPageData ();
        }
      },
      mounted ()
      {
        let self = this;

        self.refreshPageData ();
      },
        methods: {
          refreshPageData ()
          {
            let self = this;

            self.checkApplicationInProgressCount();
            self.refreshClaimsData();
            self.refreshUnfactoredClaimsData ();
            self.refreshActiveFactoringsData ();
          },

          //controllers
          unfactoredChangeDisplayedRowCount (rowCount)
          {
            let self = this;

            self.unfactoredSelectedPage = 1;
            self.unfactoredRowsPerPage =  isNaN(parseInt(rowCount))? -1 : parseInt(rowCount);
            self.refreshUnfactoredClaimsData();
          },
          factoringsChangeDisplayedRowCount (rowCount)
          {
            let self = this;

            self.overdueSelectedPage = 1;
            self.overdueRowsPerPage = isNaN(parseInt(rowCount))? -1 : parseInt(rowCount);
            self.refreshActiveFactoringsData();
          },
          changeOverduePage(page)
          {
            let self = this;

            self.overdueSelectedPage = page;
            self.refreshActiveFactoringsData()
          },
          changeUnfactoredPage(page)
          {
            let self = this;

            self.unfactoredSelectedPage = page;
            self.refreshUnfactoredClaimsData()
          },
          filterFactorings (selection)
          {
            this.overdueSelection = selection;
            this.refreshActiveFactoringsData ();
          },
          clearState (target)
          {
            let self = this;
            let array = '';
            switch (target) {
              case 'unfactored':
                array = self.unfactoredClaims;
                break;
              case 'overdue':
                array = self.overdueFactorings;
            }
            for (let obj of array)
            {
              obj.added = false;
            }
          },
          changeOverdueFactoringsStatus (item)
          {
            let self = this;

            console.log(item);
            console.log(self.overdueFactorings);
            let index = self.overdueFactorings.findIndex(function (element)
            {
              return element.Id === item.Id;
            });
            let factoring = self.overdueFactorings[index];
            factoring.added = !factoring.added;
            self.$set(self.overdueFactorings, index, factoring);
          },
          changeUnfactoredClaimsStatus (item)
          {
            let self = this;

            let index = self.unfactoredClaims.findIndex(function (element)
            {
              return element.BankClaimId === item.BankClaimId;
            });
            let claim = self.unfactoredClaims[index];
            claim.added = !claim.added;
            self.$set(self.unfactoredClaims, index, claim);
          },
          checkApplicationInProgressCount ()
          {
            let self = this;

            let applicationFetch = self.$store.dispatch('applications/getApplicationReport', {page: 1, rowsPerPage: 5, from: null, to: null, selection: 'pending', sort: {}, search: '' });
            applicationFetch.then(response =>
                    {
                      switch (response.TotalRowCount)
                      {
                        case 0:
                          self.disableApplicationLink = true;
                          break;
                        case 1:
                          self.navigateToApplicationDetailSwitch = true;
                          self.applicationDetailId = response.Rows[0].Id;
                          self.disableApplicationLink = false;
                          break;
                        default:
                          self.navigateToApplicationDetailSwitch = false;
                          self.disableApplicationLink = false;
                          break;
                      }
                    }, () =>
                    {
                      // error
                    }
            );
          },

          //claims
          refreshClaimsData ()
          {
            let self = this;
            let fetchClaims = self.$store.dispatch('claims/getClaimsModel');

            fetchClaims.then(response =>
            {
              self.claims = response;
            })
          },

          //unfactored
          unfactoredSearchRefresh (search)
          {
            let self = this;

            if (search!=='')
            {
              self.unfactoredSelectedPage = 1
            }
            self.unfactoredSearch = search;
            self.refreshUnfactoredClaimsData();
          },
          refreshUnfactoredWithSort (pagination)
          {
            let self = this;

            self.unfactoredSort = {};
            self.unfactoredSort[pagination.sortBy] = pagination.descending ? 'desc' : 'asc';
            self.refreshUnfactoredClaimsData ();
          },
          refreshUnfactoredClaimsData ()
          {
		    let self = this;

            self.loadingUnfactoredClaims = true;
		    let fetchFactorableClaims = self.$store.dispatch('claims/getFactorableClaims', {current:self.unfactoredSelectedPage, rowCount: self.unfactoredRowsPerPage, sort: self.unfactoredSort, search: self.unfactoredSearch});

            fetchFactorableClaims.then(response =>
            {
                self.processUnfactoredClaims(response);
                self.loadingUnfactoredClaims = false;
            }, () =>
            {
              // error
              self.loadingUnfactoredClaims = false
            }
            );
          },
          processUnfactoredClaims(unfactoredClaimsObj)
          {
            let self = this;

            let unfactoredClaims = unfactoredClaimsObj.Rows;
            self.unfactoredClaims = [];
            for (let unfactoredClaim of unfactoredClaims)
            {
              let unfactoredClaimClient = {

                Account: unfactoredClaim.Account,
                BankClaimId: unfactoredClaim.BankClaimId,
                Capital: unfactoredClaim.Capital,
                Created: unfactoredClaim.Created,
                DueDate: unfactoredClaim.DueDate,
                FinalDueDate: unfactoredClaim.FinalDueDate,
                Kennitala: unfactoredClaim.Kennitala,
                Name: unfactoredClaim.Name,
                added: false
              };
              self.unfactoredClaims.push(unfactoredClaimClient);
            }
            self.unfactoredClaimsRowCount = unfactoredClaimsObj.TotalRowCount;
          },

          //overdue
          overdueSearchRefresh (search)
          {
            let self = this;

            if (search !== '')
            {
              self.overdueSelectedPage = 1
            }
            self.overdueSearch = search;
            self.refreshActiveFactoringsData();
          },
          refreshOverdueWithSort (pagination)
          {
            let self = this;

            self.overdueSort = {};
            self.overdueSort[pagination.sortBy] = pagination.descending ? 'desc' : 'asc';
            self.refreshActiveFactoringsData ();
          },
          refreshActiveFactoringsData ()
          {
            let self = this;
            self.loadingOverdueFactorings = true;
            let fetchOverdueFactorings = self.$store.dispatch('claims/getClaimantsActiveFactorings', {current:self.overdueSelectedPage, rowCount: self.overdueRowsPerPage, sort: self.overdueSort, selection: 'unpaid', search: self.overdueSearch});

            fetchOverdueFactorings.then(response =>
            {
              self.processActiveFactorings(response);
              self.loadingOverdueFactorings = false;
            }, () =>
            {
              // error
              self.loadingOverdueFactorings = false;
            }
            );
          },
          processActiveFactorings(overdueFactoringsObj)
          {
            let self = this;

            let overdueFactorings = overdueFactoringsObj.Rows;
            self.overdueFactorings = [];
            for (let overdueFactoring of overdueFactorings)
            {
              let overdueFactoringClient = {

                Id: overdueFactoring.Id,
                Account: overdueFactoring.Account,
                Created: overdueFactoring.Created,
                LeftToPay: overdueFactoring.LeftToPay,
                FactoringDueDate: overdueFactoring.FactoringDueDate,
                Indicator: self.getIndicator(overdueFactoring.FactoringDueDate),
                DebtorRegistryId: overdueFactoring.DebtorRegistryId,
                DebtorName: overdueFactoring.DebtorName,
                added: false
              };
              self.overdueFactorings.push(overdueFactoringClient);
            }
            self.overdueFactoringsRowCount = overdueFactoringsObj.TotalRowCount;
          },

          //formatting
          addDays(date, days) {
            let result = new Date(date);
            result.setDate(result.getDate() + days);
            return result;
          },
          getIndicator (date)
          {
            let self = this;
            let soon;
            let newDate = new Date();
            let dateToCompare = new Date(date);
            let today = new Date(newDate.getFullYear()+'-'+(newDate.getMonth()+1)+'-'+newDate.getDate());
            soon = new Date(self.addDays(today, 5));

            if((today.valueOf()) < dateToCompare.valueOf() && (dateToCompare.valueOf() < soon.valueOf()))
            {
              return "soon";

            }else if(dateToCompare.valueOf() < today.valueOf())
            {
              return "overdue";
            }
            else if (dateToCompare.valueOf() === today.valueOf())
            {
              return 'due';
            }
          },

          //create
          createRepayment ()
          {
		    let self = this;

		    let selectedFactorings = [];
		    for (let factoring of self.overdueFactorings)
            {
              if (factoring.added)
              {
                selectedFactorings.push(factoring.Id);
              }
            }
		    self.creatingRepayment = true;
		    let repaymentFetch = self.$store.dispatch('repayments/createRepayment', {selectedFactorings: selectedFactorings, IsLegalRepayment: false});
		    repaymentFetch.then(response =>
            {
              self.$store.commit('notification/showNotificationInternal', {type:'info', msg: 'krita.notification.repaymentcreated'});
              self.refreshActiveFactoringsData();
              self.creatingRepayment = false;
            }, () =>
            {
              self.creatingRepayment = false;
            })
          },
          createFactoring ()
          {
            let self = this;

            let selectedClaims = [];
            for (let claim of self.unfactoredClaims)
            {
              if (claim.added)
              {
                selectedClaims.push(claim.BankClaimId);
              }
            }

            self.creatingFactoring = true;
            let repaymentFetch = self.$store.dispatch('applications/createFactorClaim', {SelectedBankClaims: selectedClaims, NoRefactoringRequest: false});
            repaymentFetch.then(response =>
            {
              self.$store.commit('notification/showNotificationInternal', {type:'info', msg: 'krita.notification.factoringcreated'});
              self.refreshUnfactoredClaimsData();
              self.refreshClaimsData();
              self.checkApplicationInProgressCount();
              self.creatingFactoring = false;
            }, () =>
            {
              self.creatingFactoring = false;
            })
          },

          //navigation
          navigateToFactoringDetail (id)
          {
            let self = this;

            self.$router.push('/factoring/' + id);
          },
          navigateToApplicationInProgress ()
          {
            let self = this;

            if (!self.disableApplicationLink)
            {
              if (self.navigateToApplicationDetailSwitch)
              {
                self.$router.push('/application/' + self.applicationDetailId);
              }
              else
              {
                self.$router.push('/reports/pending');
              }
            }

          }
        },
	}
</script>

<style lang="css" scoped>
.btn {
  width:100px;
  max-width:100px;
}
.pseudolink {
  color:blue;
  cursor:pointer;
}
.link {
  cursor:pointer;
}
  .controllers{
    float: right;
    margin-top: 20px;
  }
</style>
